import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LifelyProvider } from "./context/LifelyContext";
import { PlanProvider } from "./context/PlanContext";
import AuthWrapper from "./components/auth/AuthWrapper";
import ClerkAuthBridge from "./components/auth/ClerkAuthBridge";
import PlanGate from "./components/auth/PlanGate";
import Layout from "./components/layout/Layout";
import Dashboard from "./pages/Dashboard";
import MapsOverview from "./pages/MapsOverview";
import MapDetail from "./pages/MapDetail";
import ContinuityOverview from "./pages/ContinuityOverview";
import ContinuityWizard from "./pages/ContinuityWizard";
import ContinuitySettings from "./pages/ContinuitySettings";
import PrintExport from "./pages/PrintExport";
import AIAssist from "./pages/AIAssist";
import WillStatus from "./pages/WillStatus";
import Contacts from "./pages/Contacts";
import ContactExport from "./pages/ContactExport";
import Sharing from "./pages/Sharing";
import Settings from "./pages/Settings";
import Insights from "./pages/Insights";
import Help from "./pages/Help";
import JoinPricing from "./pages/join/Pricing";
import JoinUpgrade from "./pages/join/Upgrade";
import JoinUpgradeToPlus from "./pages/join/UpgradeToPlus";
import EmergencyAccessRequest from "./pages/EmergencyAccessRequest";
import NomineeAccessPage from "./pages/NomineeAccessPage";

function App() {
  return (
    <LifelyProvider>
      <ClerkAuthBridge />
      <PlanProvider>
        <BrowserRouter>
            <Routes>
              {/* Public routes - no auth required */}
              <Route path="/join/pricing" element={<JoinPricing />} />
              <Route path="/emergency" element={<EmergencyAccessRequest />} />
              <Route path="/nominee-access/:token" element={<NomineeAccessPage />} />
              
              {/* Semi-protected routes - auth required but handled internally */}
              <Route path="/join/upgrade" element={<JoinUpgrade />} />
              <Route path="/join/upgrade-to-plus" element={<JoinUpgradeToPlus />} />
              
              {/* Protected routes - auth and plan required */}
              <Route path="/" element={<Layout><AuthWrapper><PlanGate><Dashboard /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/maps" element={<Layout><AuthWrapper><PlanGate><MapsOverview /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/maps/:mapId" element={<Layout><AuthWrapper><PlanGate><MapDetail /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/continuity" element={<Layout><AuthWrapper><PlanGate><ContinuityOverview /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/continuity/setup" element={<Layout><AuthWrapper><PlanGate><ContinuityWizard /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/continuity/settings" element={<Layout><AuthWrapper><PlanGate><ContinuitySettings /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/print-export" element={<Layout><AuthWrapper><PlanGate><PrintExport /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/ai-assist" element={<Layout><AuthWrapper><PlanGate><AIAssist /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/will-status" element={<Layout><AuthWrapper><PlanGate><WillStatus /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/contacts" element={<Layout><AuthWrapper><PlanGate><Contacts /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/contacts/:contactId/export" element={<Layout><AuthWrapper><PlanGate><ContactExport /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/sharing" element={<Layout><AuthWrapper><PlanGate><Sharing /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/settings" element={<Layout><AuthWrapper><PlanGate><Settings /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/insights" element={<Layout><AuthWrapper><PlanGate><Insights /></PlanGate></AuthWrapper></Layout>} />
              <Route path="/help" element={<Layout><AuthWrapper><PlanGate><Help /></PlanGate></AuthWrapper></Layout>} />
            </Routes>
        </BrowserRouter>
      </PlanProvider>
    </LifelyProvider>
  );
}

export default App;
